import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

import { Link } from "react-router-dom"

import logo from "../../assets/images/Tamil Sangam_2023_V7_gold.png"
import logoLightPng from "../../assets/images/Tamil Sangam_2023_V7_gold.png"
import logoLightSvg from "../../assets/images/Tamil Sangam_2023_V7_gold.png"
import logoDark from "../../assets/images/Tamil Sangam_2023_V7_gold.png"

const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div
          className="navbar-brand-box p-0 pt-xl-3 
pt-lg-3  pt-sm-0 "
        >
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm ">
              <img src={logo} alt="" height="40" />
            </span>
            <span className="logo-lg ">
              <img src={logoDark} alt="" height="100" />
            </span>
          </Link>

          <Link
            to="/"
            className="logo logo-light p-0 pt-xl-3 
  pt-lg-3 pt-sm-0  "
          >
            <span className="logo-sm ">
              <img src={logoLightSvg} alt="" height="40" />
            </span>
            <span className="logo-lg ">
              <img src={logoLightPng} alt="" height="100" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
